import React from 'react'
import { Button, Modal } from 'reactstrap';

export interface Props {
  offerId: string;
  isOpen: boolean;
  onToggle: () => void;
  onConfirmation: (offerId: string) => void;
  bodyText: string;
  confirmationText: string;
  abortText: string;
  titleText: string;
}

const AcceptOfferModal: React.FC<Props> = ({ offerId, isOpen, onToggle, onConfirmation, bodyText, confirmationText, abortText , titleText}) => {
  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={isOpen}
      toggle={() => onToggle()}
    >
      <div className="modal-header">
        <h6 className="modal-title" id="modal-title-default">
          {titleText}
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <p>{bodyText}</p>
      </div>
      <div className="modal-footer">
        <Button
          color="danger"
          type="button"
          onClick={() => onConfirmation(offerId)}
        >
          {confirmationText}
        </Button>
        <Button
          className="ml-auto"
          color="link"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          {abortText}
        </Button>
      </div>
    </Modal>
  );
}

export default AcceptOfferModal
